import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Use useLayoutEffect to run before browser paints
  useLayoutEffect(() => {
    // Temporarily disable smooth scroll CSS
    const htmlElement = document.documentElement;
    const originalScrollBehavior = htmlElement.style.scrollBehavior;
    htmlElement.style.scrollBehavior = 'auto';

    // Force scroll to top
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    scrollToTop();

    // Multiple safety checks for lazy-loaded content
    const checks = [0, 10, 50, 100, 200].map(delay =>
      setTimeout(() => {
        scrollToTop();
      }, delay)
    );

    // Restore smooth scroll after navigation complete
    const restoreScroll = setTimeout(() => {
      htmlElement.style.scrollBehavior = originalScrollBehavior;
    }, 250);

    return () => {
      checks.forEach(clearTimeout);
      clearTimeout(restoreScroll);
      htmlElement.style.scrollBehavior = originalScrollBehavior;
    };
  }, [pathname]);

  return null;
};
